'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  overflow: _propTypes2.default.oneOf(['hidden', 'visible', 'scroll', 'auto', 'inherit', 'initial'])
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var overflow = _ref.overflow,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['overflow', 'style']);

  var newStyles = {};

  newStyles.overflow = overflow;

  return _extends({ style: _extends({}, newStyles, style) }, props);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvb3ZlcmZsb3cuanMiXSwibmFtZXMiOlsicHJvcFR5cGVzIiwib3ZlcmZsb3ciLCJvbmVPZiIsInBhcnNlUHJvcHMiLCJzdHlsZSIsInByb3BzIiwibmV3U3R5bGVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7QUFFTyxJQUFNQSxnQ0FBWTtBQUN2QkMsWUFBVSxvQkFBVUMsS0FBVixDQUFnQixDQUN4QixRQUR3QixFQUV4QixTQUZ3QixFQUd4QixRQUh3QixFQUl4QixNQUp3QixFQUt4QixTQUx3QixFQU14QixTQU53QixDQUFoQjtBQURhLENBQWxCOztBQVdBLElBQU1DLGtDQUFhLFNBQWJBLFVBQWEsT0FBbUM7QUFBQSxNQUFoQ0YsUUFBZ0MsUUFBaENBLFFBQWdDO0FBQUEsTUFBdEJHLEtBQXNCLFFBQXRCQSxLQUFzQjtBQUFBLE1BQVpDLEtBQVk7O0FBQzNELE1BQU1DLFlBQVksRUFBbEI7O0FBRUFBLFlBQVVMLFFBQVYsR0FBcUJBLFFBQXJCOztBQUVBLG9CQUFTRyxvQkFBWUUsU0FBWixFQUEwQkYsS0FBMUIsQ0FBVCxJQUErQ0MsS0FBL0M7QUFDRCxDQU5NIiwiZmlsZSI6Im92ZXJmbG93LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuXG5leHBvcnQgY29uc3QgcHJvcFR5cGVzID0ge1xuICBvdmVyZmxvdzogUHJvcFR5cGVzLm9uZU9mKFtcbiAgICAnaGlkZGVuJyxcbiAgICAndmlzaWJsZScsXG4gICAgJ3Njcm9sbCcsXG4gICAgJ2F1dG8nLFxuICAgICdpbmhlcml0JyxcbiAgICAnaW5pdGlhbCdcbiAgXSlcbn1cblxuZXhwb3J0IGNvbnN0IHBhcnNlUHJvcHMgPSAoeyBvdmVyZmxvdywgc3R5bGUsIC4uLnByb3BzIH0pID0+IHtcbiAgY29uc3QgbmV3U3R5bGVzID0ge31cblxuICBuZXdTdHlsZXMub3ZlcmZsb3cgPSBvdmVyZmxvd1xuXG4gIHJldHVybiB7IHN0eWxlOiB7IC4uLm5ld1N0eWxlcywgLi4uc3R5bGUgfSwgLi4ucHJvcHMgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/overflow.js
// module id = 1147
// module chunks = 0